/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon16Regular = forwardRef('ArrowShapeTriangleARightIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 4.158a1.25 1.25 0 0 1 1.919-1.056l6.065 3.842a1.25 1.25 0 0 1 0 2.112L5.92 12.897A1.25 1.25 0 0 1 4 11.841V4.158Zm1.5.455v6.774L10.848 8 5.5 4.613Z" })));
});
